import { render } from "./radio-input.vue?vue&type=template&id=3b6d0300&scoped=true"
import script from "./radio-input.vue?vue&type=script&lang=js"
export * from "./radio-input.vue?vue&type=script&lang=js"

import "./radio-input.vue?vue&type=style&index=0&id=3b6d0300&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b6d0300"],['__file',"src/views/form/components/radio-input.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3b6d0300"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3b6d0300', __exports__)) {
    console.log('reload')
    api.reload('3b6d0300', __exports__)
  }
  
  module.hot.accept("./radio-input.vue?vue&type=template&id=3b6d0300&scoped=true", () => {
    console.log('re-render')
    api.rerender('3b6d0300', render)
  })

}


export default __exports__